import React from "react";
import styles from "./LeadershipBOD.module.css";
import Image from "next/image";

interface Image {
  id: number;
  documentId: string;
  url: string;
  alternativeText: string;
}
interface TileDescription {
  id: number;
  title: string;
  description: string;
}
interface Card {
  id: number;
  title_description: TileDescription;
  images: Image[];
}
interface BoardOfDirectors {
  id: number;
  title: string;
  cards: Card[];
}
interface Props {
  data: BoardOfDirectors;
}

const LeadershipBOD: React.FC<Props> = ({ data }) => {
  function splitTitle(title = "") {
    const [name, position] = title?.split("–")?.map((part) => part.trim());
    return { name, position };
  }

  const { title, cards } = data;
  return (
    <section className={`${styles.boardSection}`}>
      <div className="container">
        <h2 className="text-center">{title}</h2>
        <div className={`${styles.borderHeading} text-center`}></div>
        <div className="row justify-content-center">
          {cards?.map((item) => {
            const title = item?.title_description?.title || "";
            const { name, position } = splitTitle(title);

            return (
              <div
                key={item?.id}
                className={`${styles.BODgrid} col-sm-6 col-md-3 `}
              >
                <div className="board-member-card">
                  <div className={`${styles.boardMember} text-center`}>
                    <div className={`${styles.imageWrapper} position-relative`}>
                      <Image
                        src={item?.images[0]?.url}
                        alt={
                          item?.images[0]?.alternativeText ||
                          "Board Member Image"
                        }
                        title={
                          item?.images[0]?.alternativeText ||
                          "Board Member Image"
                        }
                        className={`${styles.memberImage}`}
                        fill
                        style={{
                          objectFit: "cover",
                        }}
                        priority
                      />
                    </div>
                    <div className={styles.BODText}>
                      <span>
                        <h3>{name}</h3>
                        <p>{position}</p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default LeadershipBOD;
